export const skeletonCost = (number) => {
    const res = [...Array(number).keys()];
    return res;
};
